export var Paths;

(function (Paths) {
  Paths["info"] = "/info";
})(Paths || (Paths = {}));